import React from 'react';
import { Text } from '@realm-kf/halcyon-components-react';
import { _t } from '@hip/translations';
import styles from './legend.css';
var Legend = React.memo(function () { return (React.createElement("div", { className: styles.LegendWrapper },
    React.createElement(Text, { classes: styles.LegendItem, align: "center", size: "small" }, _t('appointment_booking.steps.datetime.legend_available')),
    React.createElement(Text, { classes: "".concat(styles.LegendItem, " ").concat(styles.LegendItem_unavailable), align: "center", size: "small" }, _t('appointment_booking.steps.datetime.legend_unavailable')))); });
export { Legend };
